export enum CountryCode {
  US = "United States",
  CA = "Canada",
  MX = "Mexico",
}

export enum CountryCodes {
  US = "US",
  CA = "CA",
  MX = "MX",
}
